module.exports = __webpack_public_path__ + "img/pic_feed_vip1.a3af3fee.png";